import { withTranslations } from '@/utils/Language';
import referralEn from '@/assets/i18n/referral/en.json';
import accessEventsEn from '@/assets/i18n/accessEvents/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...referralEn, ...accessEventsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/referral/${lang}.json`),
      import(`@/assets/i18n/accessEvents/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([referral, accessEvents, ui, languages, languagesTranslated]) => ({
      ...referral.default,
      ...accessEvents.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
